import { Spin } from 'antd'
import Flex from 'components/Flex'
import Page from 'modules/Page/Container/index'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import { authenticated } from 'routes/config/user'
import styled from 'styled-components'

const { AUTH_URL } = process.env

const PageFlex = styled(Flex)`
  overflow: hidden;
`
const AuthPage = ({ isAuthenticated, getStudentData, SignIn }) => {
  const navigate = useNavigate()
  const location = new useLocation()
  const lastLocation = useSelector(state => state?.auth?.lastLocation)
  const studentId = useSelector(state => state?.auth?.studentId)
  const [searchParams] = useSearchParams()
  const pathname = window.location.pathname
  const [isLoading, setIsLoading] = useState(true)
  const [studentDetails, setStudentDetails] = useState({})

  const fetchStudentData = async id => {
    let response = await getStudentData(id || studentId)
    setStudentDetails(response)
  }

  const signInUser = async () => {
    const token = searchParams.get('token')

    if (!token && !isAuthenticated) {
      window.open(AUTH_URL, '_self')
    }

    const studentId = await SignIn(token)
    fetchStudentData(studentId)
  }

  useEffect(() => {
    signInUser()
  }, [])

  useEffect(() => {
    if (studentDetails?.currentState === 0) {
      navigate(`/onboarding/activate/${studentDetails?.id}`)
      setIsLoading(false)
    }
  }, [studentDetails?.currentState ])

  useEffect(() => {
    if (isAuthenticated && studentDetails?.currentState > 0) {
      if (lastLocation === '/dashboard' && pathname === '/signin') {
        if (studentDetails?.currentState) {
            navigate('/dashboard')
        }
      }
      setIsLoading(false)
    }
  }, [isAuthenticated, studentDetails?.currentState > 0])

  return (
    <PageFlex>
      {isAuthenticated && !isLoading && studentDetails?.currentState > 0 && (
        <Page
          isOnboarding={
            location?.pathname?.includes('onboarding/register')
              ? true
              : location?.pathname?.includes('onboarding/notification')
              ? true
              : false
          }
          questionnaire={location?.pathname?.includes('questionnaire')}
        >
          <Routes>
            {authenticated.map(({ routePath, Component }) => {
              return (
                <Route
                  key={routePath}
                  path={routePath}
                  element={<Component />}
                ></Route>
              )
            })}
          </Routes>
        </Page>
      )}

      {isLoading && <Spin />}
    </PageFlex>
  )
}

export default AuthPage
